import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { NotesModalType } from "../../../../Types/MessengerType";
import { useState } from "react";
import { ToDoDropdownData } from "../../../../Data/Messenger/Messenger";

const ToDoModal: React.FC<NotesModalType> = ({ toggle, modal }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  return (
    <Modal fade className="add-popup todo-main-modal" isOpen={modal} toggle={toggle}>
      <ModalHeader>Welcome to chatzy
        <Button className="close" onClick={toggle}><span>×</span></Button>
      </ModalHeader>
      <ModalBody>
        <Form className="default-form">
          <div className="todo-task">
            <h5>Felling Lonely</h5>
            <div className="todo-main-content">
              <div className="form-group">
                <input type="checkbox" aria-label="Checkbox for following text input" />
                <Input className="w-100" type="text" placeholder="Fill Your Fillings " />
              </div>
              <div className="drop-picker gap-3">
                <Dropdown className="currency" isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
                  <div className="select"><DropdownToggle tag="span">Assign To</DropdownToggle></div>
                  <DropdownMenu>
                    <DropdownItem divider>
                      <div className="fa fa-user text-muted" />
                      <h5 className="text-muted">Assign To</h5>
                    </DropdownItem>
                    {ToDoDropdownData.map((item, index) => (<DropdownItem key={index}>{item}</DropdownItem>))}
                  </DropdownMenu>
                </Dropdown>
                <Input className="digits" type="date" name="text" />
              </div>
            </div>
          </div>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" size="sm" className="button-effect">Save</Button>
        <Button color="primary" size="sm" className="button-effect" onClick={toggle}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};

export default ToDoModal;
